import React, { Component, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as commonActions from '@common/common.action';
import * as actions from './erratas.action';
import * as editorActions from '../../editor/editor.action';
import MultiErratasContainer from '@common/multierratas/multierratas.container';
import ModalConfirmar from '@common/modalConfirmar/modalConfirmar';
import * as editor from '../../editor/editor.util';
import { verificarPlainTextMudou } from '../../editor/editor.util';
import WebapiCommon from '@common/util/webapi.common';
import { acessoPermitido } from '../../../../acessos.seguranca';
import * as acessos from '../../../../acessos.const.util';
import { LOCAL_STORAGE_USUARIO } from '../../../../localStorage.util';
import { etapasEnum, statusEtapasEnum } from '@common/util/defaultValues';
import { errors } from '../../../error/erros';
import ErratasPage from './erratas.page';
import ErrataAPI from './erratas.api';
import { editorRunat, editorUrl } from '@constants/defaultValues';
import IntlMessage from "../../../../helpers/intlMessage";
import { useState } from 'react';
import ModalEncaminhar from '@common/modalEncaminhar/modalEncaminhar';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import ExamesEmAbertoContainer from '../../etapas/macroscopia/operacoes/exames/exames.container';

function ErratasContainer(props) {

  const intl = useIntl();
  const history = useHistory();

  function translate(key) {
    return intl.formatMessage({ id: key });
  }

  const [modalVisivel, setmodalVisivel] = useState(false);
  const [modalTitulo, setmodalTitulo] = useState('');
  const [modalConteudo, setmodalConteudo] = useState(undefined);
  const [modalSize, setmodalSize] = useState('lg');
  const [callbackAutorizar, setcallbackAutorizar] = useState(undefined);
  const [modalAutorizacaoLaudar, setmodalAutorizacaoLaudar] = useState(false);
  const [justificativaCancelar, setjustificativaCancelar] = useState('');
  const [modalConfirmar, setmodalConfirmar] = useState(false);
  const modalConfirmarTitulo = translate("dashboards.examDetail.headsUp");
  const [modalConfirmarMensagem, setmodalConfirmarMensagem] = useState('');
  const [modalConfirmarType, setmodalConfirmarType] = useState('confirm');
  const [modalConfirmarClick, setmodalConfirmarClick] = useState(() => { });
  const [errataFinalizada, seterrataFinalizada] = useState(false);
  const [timeoutResize, settimeoutResize] = useState(null);
  const [ativarBotoes, setativarBotoes] = useState(false);
  const [fabErrata, setfabErrata] = useState(false);
  const [modalEncaminhar, setModalEncaminhar] = useState(false)
  const [modalEncaminharType, setModalEncaminharType] = useState('ok');
  const usuarioLocal = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USUARIO));
  const [verificarTexto, setVerificarTexto] = useState(false);
  const [textoEditor, setTextoEditor] = useState('');
  const [showModalCancelamento, setshowModalCancelamento] = useState(false);
  const [showModalConfirmarCancelamento, setshowModalConfirmarCancelamento] = useState(false);
  const laudarType = useRef('pendente');
  const eventoNovaErrataRef = useRef(undefined);
  const eventoModalConfirmar = useRef(undefined);

  function useForceUpdate() {
    const [value, setValue] = useState(0);
    return () => setValue(value + 1);
  }

  const handleResize = useForceUpdate();

  useEffect(() => {
		window.addEventListener('message', ({ data }) => {
			if (data.value) {
				if (data.value.plain) {
					setTextoEditor(data.value.plain);
				}
			}
		});

		return () => {
			window.removeEventListener('message', null, true);
			props.commonActions.mudarStatusLaudoFaturado(false);
		}

	}, []);

  useEffect(() => {
    props.commonActions.alterarVisibilidadeAbas({});
    props.actions.atualizarErrata({});
    props.actions.selectErrata(false);
    document.title = 'Anatomia Patológica';

    try {
      editor.Inicializar(props, etapasEnum.ERRATA.toLowerCase());
    } catch (error) {
      let message = error.message;
      let title = '';
      let origin = `Etapa: ${etapasEnum.ERRATA}`;
      const code = 101;

      errors.map(err => {
        if (err.code === code) {
          title = err.title;
        }
        return err;
      });
      window.location.replace(
        `/error/${btoa(title)}/${btoa(message)}/${btoa(code)}/${btoa(origin)}/`
      );
    }

    const laudarEtapaRequest = {
      pendente: true,
      notificacaoCancer: false,
      exameId: props.detalhes.exameId,
      medicoSolicitante: props.detalhes.solicitante,
      medicoEtapa: props.editor.medExecutante
    };

    props.commonActions.argumentosSalvarEtapaLaudo(laudarEtapaRequest);

    let etapa = props.detalhes.etapas.find(
      el => el.etapa.toLowerCase() === etapasEnum.ERRATA.toLowerCase()
    );
    seterrataFinalizada(etapa && etapa.status === statusEtapasEnum.REALIZADO)
    window.addEventListener('resize', handleResize);
    setTimeout(() => {
      iniciarModal(etapa && etapa.status === statusEtapasEnum.REALIZADO);
    }, 600);

    return () => {
      editor.finalizar(props.commonActions);
      settimeoutResize(null);
    }
  }, [])

  function alterarFullscreen() {
    props.commonActions.preencherAtalho('ctrl+alt+f10');
  }

  function iniciarModal(efinalizada, tentativa) {
    if (!props.editorInicializado && tentativa < 5) {
      tentativa = tentativa + 1;

      setTimeout(() => {
        iniciarModal();
      }, 1000);
    } else if (tentativa >= 5) {
      tentativa = 0;
      props.commonActions.showAlerta(
        'erro',
        'Não foi possivel iniciar os registros de Errata',
        2000
      );
    } else {
      props.textRtf && showModal('1');
    }
  }

  function setJustificativa(texto) {
    setjustificativaCancelar(texto)
  }

  function fechar() {
    // let etapa = props.detalhes.etapas.find(
    //   e => e.etapa === etapasEnum.ERRATA
    // );

    // if (
    //   etapa.status !== statusEtapasEnum.REALIZADO &&
    //   props.eventokeyUpFoiDisparadoNoEditor
    // ) {
    //   setmodalTitulo('Salvar alterações');
    //   setmodalConteudo((<div>Salvar alterações no texto do laudo antes de sair?</div>));
    // } else {
    //   history.goBack();
    //   props.commonActions.preenhcerHistoricoInconformidades(undefined);
    //   props.commonActions.atualizarLarguraEditor('100%');
    //   props.commonActions.showEditor(false);
    //   props.commonActions.showFadeCarregando(false);
    // }
    props.commonActions.changeFecharTela(true);
    verificarPlainTextMudou();
  }

  function _fechar() {
    history.goBack();
    //props.commonActions.atualizarDetalhes(undefined);
    props.commonActions.preenhcerHistoricoInconformidades(undefined);
    props.commonActions.atualizarLarguraEditor('100%');
    props.commonActions.showEditor(false);
  }

  function fecharModalConfirmar() {
    setmodalConfirmar(!modalConfirmar)
  };

  function showModal(index) {
    let componente = undefined;
    let titulo = '';
    let size = 'lg';
    eventoNovaErrataRef.current = novaErrata;
    eventoModalConfirmar.current = confirmModal;

    switch (index) {
      case '1':
        componente = <MultiErratasContainer />;
        titulo = 'Erratas: Selecione o texto';
        setmodalConteudo(componente);
        setmodalTitulo(titulo);
        setmodalVisivel(true);
        setmodalSize(size);
        break;

      case '2':
        setmodalConfirmarMensagem(translate('dashboards.examDetail.errataInformed'));
        setmodalConfirmarClick(() => {
          fecharModalConfirmar();
          laudar(false, false);
        }),
          setmodalConfirmar(true);
        break;

      case '3':
        setmodalConfirmarMensagem(translate('dashboards.examDetail.errataInformed'));
        setmodalConfirmarClick(() => {
          fecharModalConfirmar();
          laudar(true, false);
        }),
          setmodalConfirmar(true);
        break

      case '4':
        setmodalConfirmarMensagem(intl.formatMessage({ id: 'dashboards.examDetails.doctorPerformingReport' }));
        setmodalConfirmarType('ok');
        setmodalConfirmarClick(() => {
          fecharModalConfirmar();
        }),
          setmodalConfirmar(true);
        break

      case '5':
        setmodalConfirmarMensagem(<IntlMessage id="dashboards.examDetail.notTyped" />);
        setmodalConfirmarType('ok');
        setmodalConfirmarClick(() => {
          fecharModalConfirmar();
        });
        setmodalConfirmar(true);
        break

      case '6':
        setmodalConfirmarMensagem(`O recebimento do material do laudo ${props.detalhes.laudo} ainda não foi realizado ou finalizado`);
        setmodalConfirmarTypesetmodalConfirmarMensagem('ok');
        setmodalConfirmarClicksetmodalConfirmarMensagem(() => {
          fecharModalConfirmar();
        });
        setmodalConfirmarsetmodalConfirmarMensagem(true);
        break

      case '7':
        componente = <ExamesEmAbertoContainer />;
        titulo = intl.formatMessage({ id: "dashboards.examDetails.openExamReport" });
        setmodalConteudo(componente);
        setmodalTitulo(titulo);
        setmodalVisivel(true);
        setmodalSize(size);
        eventoNovaErrataRef.current = undefined;
        eventoModalConfirmar.current = undefined;
        break;

      default:
        componente = undefined;
        break;
    }
  }

  function closeModal() {
    setmodalVisivel(false);
    props.actions.selectErrata(false);
  }

  function confirmModal(el) {
    const frame = document.getElementById('iframe-editor');
    if (frame !== null) {
      frame.style.display = 'block';

      const textRtf = props.errata.rtf;
      const idRtf = props.errata.id;

      props.editorActions.editorRtf(textRtf);
      props.editorActions.idRtf(idRtf);
      props.commonActions.preencherIdRtf(idRtf);

      props.commonActions.atualizarDetalhes({
        ...props.detalhes,
        medErrata: props.errata.medicoExecutante
      });

      if (!textRtf) {
        props.commonActions.showFadeCarregando(false);
      } else {
        frame.contentWindow.postMessage(
          {
            method: 'clearDocument'
          },
          editorUrl
        );
        frame.contentWindow.postMessage(
          {
            method: 'substituirTexto',
            text: textRtf,
            type: 'rtf',
            runat: editorRunat,
            breakLine: false,
            cleanBefore: true
          },
          editorUrl
        );
      }
    }
    setmodalVisivel(false);
    setativarBotoes(true);

    props.actions.selectErrata(false);
  }

  function novaErrata() {
    const frame = document.getElementById('iframe-editor');
    if (frame !== null) {
      frame.contentWindow.postMessage(
        {
          method: 'clearDocument'
        },
        editorUrl
      );
      setfabErrata(props.editor.textRtf !== '' || props.selectErrata)
      props.editorActions.idRtf(0);
      props.commonActions.preencherIdRtf(0);
      props.editorActions.editorRtf('');
      props.commonActions.atualizarDetalhes({
        ...props.detalhes,
        medErrata: null
      });
      setmodalVisivel(false);
      setativarBotoes(true);
      props.actions.selectErrata(false);
    }
  }

  function confirmarCancelamentoEtapas() {
    setshowModalConfirmarCancelamento(true);
  }

  function toggleModalConfirmarCancelamento() {
    setshowModalConfirmarCancelamento(!showModalConfirmarCancelamento);
  }

  function cancelamentoErratas() {
    setshowModalCancelamento(true);
  }

  function toggleModalCancelamento() {
    setshowModalCancelamento(false);
  }

  function cancelarEtapa() {
    props.commonActions.showFadeCarregando(true);
    ErrataAPI.cancelamentoErrata(
      props.detalhes.laudo,
      justificativaCancelar
    )
      .then(res => {
        WebapiCommon.obterStatusEtapasLaudo(props.detalhes.laudo).then(
          etapas => {
            props.commonActions.atualizarStatusDasEtapasDoLaudo(
              etapas,
              props.detalhes.laudo
            );
            props.commonActions.showEditor(false);
            props.commonActions.showFadeCarregando(false);
            toggleModalCancelamento();
            toggleModalConfirmarCancelamento();
            _fechar();
          }
        );
      })
      .catch(err => {
        props.commonActions.showFadeCarregando(false);
        toggleModalCancelamento();
        toggleModalConfirmarCancelamento();
      });
  }

  function verificarLaudar(status) {
    let material = props.detalhes.etapas.find(
      e => e.etapa === etapasEnum.MATERIAL
    );
    let conclusao = props.detalhes.etapas.find(
      e => e.etapa === etapasEnum.CONCLUSAO
    );

    if (material.status !== statusEtapasEnum.REALIZADO) {
      return showModal('6');
    }

    if (
      (props.exameFinalizado ||
        conclusao.status === statusEtapasEnum.REALIZADO) &&
      status === 'concluir'
    ) {
      return showModal('2');
    } else if (
      (props.exameFinalizado ||
        conclusao.status === statusEtapasEnum.REALIZADO) &&
      status === 'pendente'
    ) {
      return showModal('3');
    }

    if (status !== 'pendente') {
      laudarEtapa(false, false);
    } else {
      laudarEtapa(true, false);
    }
  }

  const encaminharSegundaOpiniao = () => {
    setModalEncaminhar(!modalEncaminhar)
  }

  const fecharModalEncaminhar = () => {
    setModalEncaminhar(!modalEncaminhar);
  };

  function construirBotoes() {
    let botoes = [];

    botoes.push({
      backgroundColor: '#4375A3',
      className: 'mv-basico-imprimir',
      color: '#ffffff',
      texto: props.intl.formatMessage({ id: 'dashboards.reports.printOut' }),
      onClick: () => editor.Imprimir(props.commonActions)
    });

    botoes.push({
      backgroundColor: '#3f8642',
      label: '2',
      color: '#ffffff',
      texto: props.intl.formatMessage({ id: 'dashboards.referral.referral' }),
      onClick: () => encaminharSegundaOpiniao(),
    });

    if (acessoPermitido(props.usuario, acessos.ExamesEmAberto))
    {
      botoes.push({
        backgroundColor: '#17a2b8',
        className: 'fas fa-flask',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetails.openExams' }),
        totalizador: props.quantidadeLaudosEmAberto,
        onClick: () => {
          showModal('7');
        }
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Errata) &&
      (props.textRtf || fabErrata)
    ) {
      botoes.push({
        label: 'E',
        backgroundColor: '#f44336',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetails.errata' }),
        onClick: () => {
          showModal('1');
        }
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Errata) &&
      acessoPermitido(props.usuario, acessos.Concluir)
    ) {
      botoes.push({
        disabled: !props.errata,
        backgroundColor: '#3f8642',
        className: 'fas fa-save',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.laud' }),
        onClick: () => {
          laudarType.current = 'concluir';
          verificaEditor();
        }
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Errata) &&
      acessoPermitido(props.usuario, acessos.ConcluirPendente)
    ) {
      botoes.push({
        backgroundColor: '#b81717',
        className: 'far fa-save',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.laudPendent' }),
        onClick: () => {
          laudarType.current = 'pendente';
          verificaEditor();
        }
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.CancelamentoErrata) &&
      errataFinalizada
    ) {
      botoes.push({
        backgroundColor: '#b81717',
        className: 'mv-basico-cancelar',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.Cancellation' }),
        atalho: 'CTRL+ALT+N',
        onClick: () => {
          setshowModalCancelamento(!showModalCancelamento);
        }
      });
    }

    botoes.push({
      backgroundColor: '#bbbbbb',
      label: 'F',
      color: '#ffffff',
      texto: props.intl.formatMessage({ id: 'dashboards.examDetail.close' }),
      onClick: () => {
        fechar();
      }
    });

    return botoes;
  }

  useEffect(() => {
		if (textoEditor !== undefined && verificarTexto) {
			setVerificarTexto(false);
			props.commonActions.showFadeCarregando(true);
			if (!textoEditor || textoEditor.trim() === '') {
				props.commonActions.showFadeCarregando(false);
				return showModal('5');
			}
      props.commonActions.showFadeCarregando(false);
				return verificarLaudar(laudarType.current);
    }
    props.commonActions.showFadeCarregando(false);

	}, [textoEditor, verificarTexto]);

  function verificaEditor() {
    props.commonActions.showFadeCarregando(true);
    const frame = document.getElementById('iframe-editor');

    if (frame !== null) {
      frame.contentWindow.postMessage(
        {
          method: 'recuperarTextoRtfAndPlainText',
          urlHost: editorUrl,
          args: {
            action: 'getPlainText'
          }
        },
        editorUrl
      );
    }

    setTimeout(() => {
			props.commonActions.showFadeCarregando(false);
			return setVerificarTexto(true);
		}, 200);

  }

  function laudar(pendente, concluir) {
    const status = pendente
      ? statusEtapasEnum.PENDENTE
      : statusEtapasEnum.REALIZADO;
    props.editorActions.ChangeStatus(status);
    laudarEtapa(pendente, concluir);

  }

  function laudarEtapa(pendente, concluir) {
    let laudarEtapaRequest = {
      ...props.laudarEtapaRequest,
      pendente: pendente,
      concluirLaudo: concluir,
      medicoSolicitante: props.detalhes.solicitante,
      medicoEtapa: props.editor.medExecutante,
      medicoLogadoId: usuarioLocal.medicoId,
    };

    let exec = laudarEtapaRequest.medicoEtapa;

    if (!usuarioLocal.medicoId && !pendente) {
      props.commonActions.showAlerta(
        'erro',
        translate("dashboards.examDetail.onlyDoctors"),
        2000
      );
      return;
    }

    if (!exec) {
      showModal('4');
      return;
    }

    props.editorActions.ChangeMedExecutante(exec);

    if (usuarioLocal.isResidente && !pendente) {
      setmodalAutorizacaoLaudar(true);
      setcallbackAutorizar({
        sucesso: medico_autorizou => {
          setmodalAutorizacaoLaudar(false);
          editarMedico(medico_autorizou);
          props.commonActions.argumentosSalvarEtapaLaudo(
            laudarEtapaRequest
          );
          editor.laudar(props.commonActions);
          props.commonActions.showAlerta(
            'sucesso',
            intl.formatMessage({id:"dashboards.examDetail.reportSave"}),
            2000
          );
        },
        error: () => {
          props.commonActions.showAlerta(
            'erro',
            translate("dashboards.examDetail.notAllowed"),
            2000
          );
        }
      })
    } else {
      props.commonActions.argumentosSalvarEtapaLaudo(laudarEtapaRequest);
      editor.laudar(props.commonActions);
      props.commonActions.showAlerta(
				'sucesso',
				intl.formatMessage({id:"dashboards.examDetail.reportSave"}),
				2000
			);
    }
  }

  function alterarVisibilidadeAbas(propriedadeNoEstado) {
    const visibilidade = !props[propriedadeNoEstado];
    const larguraEditor = visibilidade
      ? 'calc(100% - 33.333333% - 10px)'
      : '100%';
    props.commonActions.alterarVisibilidadeAbas({
      [propriedadeNoEstado]: visibilidade
    });
    props.commonActions.atualizarLarguraEditor(larguraEditor);
  }

  return (
    <React.Fragment>
      <ModalEncaminhar
        toggleModalEncaminhar={() => setModalEncaminhar(!modalEncaminhar)}
        type={modalEncaminharType}
        showModalEncaminhar={modalEncaminhar}
        titulo={'Encaminhar'}
        mensagem={'Encaminhar'}
        confirmar={() => fecharModalEncaminhar()}
        laudo={props.detalhes.laudo}
        commonActions={props.commonActions}
      />
      <ModalConfirmar
        toggleModalConfirmar={() => setmodalConfirmar(!modalConfirmar)}
        type={modalConfirmarType}
        showModalConfirmar={modalConfirmar}
        titulo={modalConfirmarTitulo}
        mensagem={modalConfirmarMensagem}
        confirmar={modalConfirmarClick}
      />
      <ErratasPage
        usuario={props.usuario}
        modalVisivel={modalVisivel}
        modalTitulo={modalTitulo}
        modalConteudo={modalConteudo}
        modalSize={modalSize}
        modalBtnConfirmar={props.selectErrata}
        closeModal={(e) => closeModal(e)}
        confirmModal={eventoModalConfirmar.current}
        novaErrata={eventoNovaErrataRef.current}
        detalhes={props.detalhes}
        construirBotoes={construirBotoes()}
        acessoPermitido={acessoPermitido}
        altura={window.innerHeight - props.altura - 214}
        alterarFullscreen={(e) => alterarFullscreen(e)}
        modalAutorizacaoLaudar={modalAutorizacaoLaudar}
        callbackAutorizar={callbackAutorizar}
        showModalCancelamento={showModalCancelamento}
        toggleModalCancelamento={() => setshowModalCancelamento(!showModalCancelamento)}
        showModalConfirmarCancelamento={showModalConfirmarCancelamento}
        toggleModalConfirmarCancelamento={() => setshowModalConfirmarCancelamento(!showModalConfirmarCancelamento)}
        cancelarEtapa={(e) => cancelarEtapa(e)}
        showModalConfirmacaoCancelamento={(e) => cancelamentoErratas(e)}
        justificativaCancelar={justificativaCancelar}
        setJustificativa={(e) => setJustificativa(e)}
        fecharModalAutorizacao={() => setmodalAutorizacaoLaudar(false)}
        errataFinalizada={errataFinalizada}
        alterarVisibilidadeAbas={(e) => alterarVisibilidadeAbas(e)}
        visibilidadeListaLaminas={props.visibilidadeListaLaminas}
        visibilidadeAutotexto={props.visibilidadeAutotexto}
        visibilidadeListagemAnexo={props.visibilidadeListagemAnexo}
        visibilidadeLaudosAnteriores={props.visibilidadeLaudosAnteriores}
        visibilidadeHistoricoLaudo={props.visibilidadeHistoricoLaudo}
        quantidadeLaudosAnteriores={props.quantidadeLaudosAnteriores}
      />
    </React.Fragment>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    editorActions: bindActionCreators(editorActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    editor: state.editor,
    usuario: state.usuario,
    errata: state.erratas.errata,
    selectErrata: state.erratas.selectErrata,
    textRtf: state.editor.textRtf,
    altura: state.commonReducer.altura,
    detalhes: state.commonReducer.detalhes,
    editorInicializado: state.commonReducer.editorInicializado,
    laudarEtapaRequest: state.commonReducer.laudarEtapaRequest,
    listagem: state.commonReducer.listagem,
    exameFinalizado: state.commonReducer.exameFinalizado,
    visibilidadeListaLaminas: state.commonReducer.visibilidadeListaLaminas,
    visibilidadeAutotexto: state.commonReducer.visibilidadeAutotexto,
    visibilidadeLaudosAnteriores: state.commonReducer.visibilidadeLaudosAnteriores,
    visibilidadeListagemAnexo: state.commonReducer.visibilidadeListagemAnexo,
    visibilidadeHistoricoLaudo: state.commonReducer.visibilidadeHistoricoLaudo,
    quantidadeLaudosAnteriores: state.commonReducer.quantidadeLaudosAnteriores,
    quantidadeLaudosEmAberto: state.commonReducer.quantidadeLaudosEmAberto
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ErratasContainer);


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/erratas/erratas.container.js